import { getField, updateField } from 'vuex-map-fields'
import api from '../api'

export const state = {
    params: {
        page: 1,
    },

    list: [],

    selectedItems: [],

    loading: false,

    accountForm: {
        companyName: '',
        hostName: '',
        country: {
            name: 'Japan'
        },
        subscription: {
            from: '',
            to: ''
        },
        userAllocation: '',
        categories: '',
        zipNumber: '',
        phone: '',
        email: '',
        annualCharge: '',
        company_type: {}
    },

    isUpdateAccount: false,

    hasFormChangeChecker: {},
    hasFormChanged: false,

    isFormComplete: false,

    accountDetails: {},
    accountDetailsLoading: false
}

export const actions = {
    async getAccountDetails({ state }, payload) {
        state.accountDetailsLoading = true
        const { data } = await api('get', `${payload}`)

        state.accountDetails = data.data
        state.accountDetailsLoading = false
    },

    async updateAccount({ state, commit, dispatch }, payload) {
        state.formLoading = true

        const { data } = await api('post', `/cms/client/update`, payload)

        await commit('modal/toggleNotification', { notificationName: '' }, { root: true })

        if (data.status !== 200) {
            state.formLoading = false

            const errors = Object.keys(data.errors).reduce((result, item) => {
                const errorItem = `- ${data.errors[item].join(`<br> - `).replace(/\./g, '')}`

                result.push(errorItem)

                return result
            }, []).join('<br>')

            commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'warning',
                notificationDesc: `${errors}`,
            }, { root: true })
            return
        }

        await commit('clearOverview')

        state.accountDetails = data.data

        await commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'success',
            notificationDesc: 'Successfully updated account.',
        }, { root: true })

        await dispatch('modal/closeModal', {}, { root: true })

        state.formLoading = false
    },

    async rejectAccount({ state, commit }, payload) {
        state.formLoading = true

        const { data, status } = await api('post', `/cms/client/reject`, payload)

        if (status) {
            state.accountDetails.status = 2

            await commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Successfully rejected an account.',
            }, { root: true })

            state.formLoading = false
            return
        }
        
        state.formLoading = false

        const errors = Object.keys(data.errors).reduce((result, item) => {
            const errorItem = `- ${data.errors[item].join(`<br> - `).replace(/\./g, '')}`

            result.push(errorItem)

            return result
        }, []).join('<br>')

        commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'failed',
            notificationDesc: `${errors}`,
        }, { root: true })
        return
    },

    async enableDisableAccount({ state, commit }, payload) {
        state.formLoading = true

        const { data, status } = await api('post', `cms/client/enable-disable`, payload)

        await commit('modal/toggleNotification', { notificationName: '' }, { root: true })

        if (status) {
            await commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Successfully updated account status.',
            }, { root: true })

            state.formLoading = false
            state.accountDetails.is_disabled = payload.get('disable') === '1' ? 1 : 0
            return
        }
        
        state.formLoading = false

        const errors = Object.keys(data.errors).reduce((result, item) => {
            const errorItem = `- ${data.errors[item].join(`<br> - `).replace(/\./g, '')}`

            result.push(errorItem)

            return result
        }, []).join('<br>')

        commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'warning',
            notificationDesc: `${errors}.`,
        }, { root: true })
        return
    },

    async getRecordsList({ state }) {
        state.loading = true

        // const { data } = await api('get', payload)

        // state.accountRequest = data.list

        setTimeout(() => {
            state.list = [
                {
                    'id': '1',
                    'invoice_no': '1',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                },

                {
                    'id': '123',
                    'invoice_no': '2',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                },

                {
                    'id': '135',
                    'invoice_no': '3',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                },

                {
                    'id': '146',
                    'invoice_no': '4',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                },

                {
                    'id': '715',
                    'invoice_no': '5',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                },

                {
                    'id': '815',
                    'invoice_no': '5',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                },

                {
                    'id': '195',
                    'invoice_no': '5',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                },

                {
                    'id': '015',
                    'invoice_no': '5',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                },

                {
                    'id': '125',
                    'invoice_no': '5',
                    'Issuance Date': '11/11/2020',
                    'Due Date': '11/11/2020',
                    'Amount': '$420',
                    'Status': 'Pending',
                    'hehe': 'test'
                }
            ]

            state.loading = false
        }, 1000);
    },

    async getSessionList({ state }) {
        state.loading = true

        setTimeout(() => {
            state.list = [{ "id": 715, "session_name": "asdasd", "session_type": "Research", "gathering_type": "Interval", "active_users": 0, "status": 0, "session_start": "2019-09-30 00:00:00", "session_privacy": 0, "zone_name": "Asia/Kabul (GMT+4.5)", "session_end": "2019-10-05 23:50:00", "average_emotion": "tense", "latest_emotion_value": "tense", "participants": 2, "tags": [], "daytime": [{ "id": 32427, "session_id": 715, "position": 1, "day": "monday", "date": "2019-09-30", "start_time": "00:00:00", "end_time": "23:50:00", "deleted_at": null, "created_at": "2019-10-03 13:49:48", "updated_at": "2019-10-03 13:49:48" }, { "id": 32428, "session_id": 715, "position": 1, "day": "thursday", "date": "2019-10-03", "start_time": "00:00:00", "end_time": "23:50:00", "deleted_at": null, "created_at": "2019-10-03 13:49:48", "updated_at": "2019-10-03 13:49:48" }, { "id": 32429, "session_id": 715, "position": 1, "day": "friday", "date": "2019-10-04", "start_time": "00:00:00", "end_time": "23:50:00", "deleted_at": null, "created_at": "2019-10-03 13:49:48", "updated_at": "2019-10-03 13:49:48" }] }, { "id": 714, "session_name": "asdasda", "session_type": "Corporate", "gathering_type": "Interval", "active_users": 0, "status": 0, "session_start": "2019-09-30 00:00:00", "session_privacy": 0, "zone_name": "Asia/Kabul (GMT+4.5)", "session_end": "2019-10-05 23:50:00", "average_emotion": "tense", "latest_emotion_value": "tense", "participants": 1, "tags": [], "daytime": [{ "id": 32422, "session_id": 714, "position": 1, "day": "monday", "date": "2019-09-30", "start_time": "00:00:00", "end_time": "23:50:00", "deleted_at": null, "created_at": "2019-09-30 18:20:23", "updated_at": "2019-09-30 18:20:23" }] }, { "id": 713, "session_name": "dasdasd", "session_type": "Movie", "gathering_type": "Interval", "active_users": 0, "status": 0, "session_start": "2019-09-30 00:00:00", "session_privacy": 0, "zone_name": "Asia/Kabul (GMT+4.5)", "session_end": "2019-10-04 23:40:00", "average_emotion": "tense", "latest_emotion_value": "tense", "participants": 1, "tags": [], "daytime": [{ "id": 32421, "session_id": 713, "position": 1, "day": "monday", "date": "2019-09-30", "start_time": "00:00:00", "end_time": "23:40:00", "deleted_at": null, "created_at": "2019-09-30 18:19:20", "updated_at": "2019-09-30 18:19:20" }] }, { "id": 705, "session_name": "Test Session 1", "session_type": "Fitness", "gathering_type": "Interval", "active_users": 0, "status": 0, "session_start": "2019-09-30 00:00:00", "session_privacy": 0, "zone_name": "Asia/Kabul (GMT+4.5)", "session_end": "2019-10-04 23:50:00", "average_emotion": null, "latest_emotion_value": null, "participants": 2, "tags": [], "daytime": [{ "id": 32413, "session_id": 705, "position": 1, "day": "monday", "date": "2019-09-30", "start_time": "00:00:00", "end_time": "23:50:00", "deleted_at": null, "created_at": "2019-09-30 17:51:24", "updated_at": "2019-09-30 17:51:24" }] }]

            state.loading = false
        }, 1000)
    }
}

export const mutations = {
    updateField,

    clearOverview () {
        state.accountDetails = {}
    },

    clearList () {
        state.params = {
            page: 1,
        }

        state.list = []

        state.selectedItems = []

        state.loading = false
    },

    clearForm () {
        state.accountForm = {
            companyName: '',
            hostName: '',
            country: {
                name: 'Japan'
            },
            subscription: {
                from: '',
                to: ''
            },
            userAllocation: '',
            categories: '',
            zipNumber: '',
            phone: '',
            email: '',
            annualCharge: '',
            company_type: {}
        }

        state.hasFormChangeChecker = {}
        state.hasFormChanged = false

        state.isFormComplete = false

        state.isUpdateAccount = false
    },

    setFormChangedChecker () {
        state.hasFormChangeChecker = {
            ...JSON.parse(JSON.stringify(state.accountForm))
        }
    },

    hasFormChanged () {
        const accountForm = state.accountForm
        const formChecker = state.hasFormChangeChecker
        const stringifyObj = (obj) => JSON.stringify(obj)

        for (const property in accountForm) {
            const formProperty = accountForm[property]
            const formCheckerProperty = formChecker[property]

            if (typeof accountForm[property] === 'object') {
                const stringObjForm = stringifyObj(formProperty)
                const stringObjFormChecker = stringifyObj(formCheckerProperty)

                if (stringObjForm !== stringObjFormChecker) {
                    state.hasFormChanged = true
                    return
                }

            } else {
                if (formProperty !== formCheckerProperty) {
                    state.hasFormChanged = true
                    return
                }
            }
        }
    },

    isFormComplete () {
        state.isFormComplete = true
        const accountForm = state.accountForm

        for (const property in accountForm) {
            const formProperty = accountForm[property]
            const nonRequiredProperty = ['partner']
            
            if (nonRequiredProperty.indexOf(property) === -1) {
                if (typeof formProperty === 'object') {

                    if (!Object.keys(formProperty).length) return

                    for (const objProperty in formProperty) {
                        if (!formProperty[objProperty]) {
                            state.isFormComplete = false
                            return
                        }
                    }

                } else {
                    if (formProperty === '') {
                        state.isFormComplete = false
                        return
                    }
                }
            }
        }
    }
}

const getters = {
    getField
}

export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true
}
